.title {
  margin-block: var(--rc-theme-spacing-xxs);
}
